import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { classes, st } from './ErrorMessageWrapper.cssVars.st.css';
export class ErrorMessageWrapper extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_getMessage", () => {
      const {
        message,
        messageId
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.message,
        "data-hook": "errormessagewrapper-message",
        id: messageId
      }, /*#__PURE__*/React.createElement(ErrorSmall, {
        className: classes.icon,
        "aria-hidden": true
      }), message);
    });
  }
  render() {
    const {
      className,
      visible,
      suffixText,
      'data-hook': dataHook
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: st(classes.root, {
        visible
      }, className),
      "data-hook": dataHook
    }, visible && (suffixText ? /*#__PURE__*/React.createElement("div", {
      className: classes.messageWithSuffix
    }, this._getMessage(), suffixText) : this._getMessage()));
  }
}
_defineProperty(ErrorMessageWrapper, "displayName", 'ErrorMessageWrapper');
_defineProperty(ErrorMessageWrapper, "defaultProps", {
  visible: false
});
//# sourceMappingURL=ErrorMessageWrapper.js.map